import { render, staticRenderFns } from "./comExtraCopy.vue?vue&type=template&id=0cc21882"
import script from "./comExtraCopy.vue?vue&type=script&lang=js"
export * from "./comExtraCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports